import { render, staticRenderFns } from "./diagnose.vue?vue&type=template&id=5f846419&scoped=true&"
import script from "./diagnose.vue?vue&type=script&lang=js&"
export * from "./diagnose.vue?vue&type=script&lang=js&"
import style0 from "./diagnose.vue?vue&type=style&index=0&id=5f846419&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f846419",
  null
  
)

export default component.exports